import TermsIcon from "../images/TermsIcon"
import AssetsIcon from "../images/AssetsIcon"
import AssetsActiveIcon from "../images/AssetsActiveIcon"
import Assets from "../page/Assets/Assets"
import EmployeesIcon from "../images/Employees"
import EmployeesActiveIcon from "../images/EmployeesActiveIcon"
import CreateEmployees from "../page/Employees/CreateEmployees"
import Employees from "../page/Employees/Employees"
import PageAssets from "../page/Assets/PageAssets"

const FiananceSideBar = [
    {
        index: 1,
        name: "Assets",
        show: true,
        showRoute: true,
        path: "/assets",
        component: Assets,
        image: AssetsIcon,
        imageActive: AssetsActiveIcon
    },
    {
        index: 2,
        name: "Assets",
        show: false,
        showRoute: true,
        path: "/assets/new",
        component: PageAssets,
        image: AssetsIcon,
        imageActive: AssetsActiveIcon
    },
    {
        index: 3,
        name: "Assets",
        show: false,
        showRoute: true,
        path: "/assets/:id",
        component: PageAssets,
        image: TermsIcon,
        imageActive: AssetsActiveIcon
    },
    {
        index: 4,
        name: "Employees",
        show: true,
        showRoute: true,
        path: "/employees",
        component: Employees,
        image: EmployeesIcon,
        imageActive: EmployeesActiveIcon
    },
    {
        index: 5,
        name: "Employees",
        show: false,
        showRoute: true,
        path: "/employees/new",
        component: CreateEmployees,
        image: EmployeesIcon,
        imageActive: EmployeesActiveIcon
    },
    {
        index: 6,
        name: "Employees",
        show: false,
        showRoute: true,
        path: "/employees/:id",
        component: CreateEmployees,
        image: EmployeesIcon,
        imageActive: EmployeesActiveIcon
    },
]
export default FiananceSideBar